import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.BulkActionsPanel', {
    itemsSelected: '{count} {count, plural, one {item} other {items}} selected',
    edit: 'Edit',
    clone: 'Clone',
    delete: 'Delete',
    searchPlaceholder: 'Search',
});
